import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { GetLibraryMembersResponse } from '../getLibraryMembers';

export type GetLibraryFolderMembersDTO = {
  folderId: number;
};

export const getLibraryFolderMembersQueryKey = {
  list: ['getLibraryFolderMembers'] as const,
};

const url = `${PREFIX_URL}/library/folders/:folderId/members`;

export const getLibraryFolderMembers = ({
  folderId,
}: GetLibraryFolderMembersDTO): Promise<GetLibraryMembersResponse> => {
  const URL = generateRoutePath(url, { folderId });

  return axios.get(URL);
};
type QueryFnType = typeof getLibraryFolderMembers;

type UseGetLibraryFolderMembersOptions = {
  folderId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetLibraryFolderMembers = ({
  folderId,
  config,
}: UseGetLibraryFolderMembersOptions) => {
  return useQuery({
    queryKey: [...getLibraryFolderMembersQueryKey.list, folderId],
    queryFn: () => getLibraryFolderMembers({ folderId }),
    // staleTime: Infinity,
    // cacheTime: 0,
    ...config,
  });
};
